import { Fit, Layout, useRive } from '@rive-app/react-canvas'
import paywallRive from '~/assets/anim/paywall.riv'

export function Hero() {
  const { RiveComponent, rive } = useRive({
    src: paywallRive,
    autoplay: true,
    layout: new Layout({ fit: Fit.FitHeight }),
  })
  return (
    <div
      className="-mx-8 h-[308px] w-screen opacity-0 transition-opacity duration-300 data-[loaded=true]:opacity-100"
      data-loaded={!!rive}
    >
      <RiveComponent className="h-full" />
    </div>
  )
}
